export default "__VITE_ASSET__Cl$VEvpq__";